import { EventEmitter, Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class RecorridoService {
  recorridoSeleccionado$ = new EventEmitter<any>();
  constructor(private gqlclient: GraphQLClient) {}

  // {
  //   "codigo": -1,
  //   "chofer_rut": -1,
  //   "camion_patente": "",
  //   "sucursal_codigo": 1,
  //   "rut_empresa": 76150970
  // }
  obtenerSegunFiltro(
    inputParams: {
      codigo: number;
      chofer_rut: number;
      camion_patente: string;
      sucursal_codigo: number;
      rut_empresa: number;
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($codigo: Decimal, $chofer_rut: Decimal, $camion_patente: String, $sucursal_codigo: Decimal, $rut_empresa: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            recorrido {
              obtenerSegunFiltro(
                filtro: { exacto: { codigo: $codigo, chofer_rut: $chofer_rut, camion_patente: $camion_patente, sucursal_codigo: $sucursal_codigo, rut_empresa: $rut_empresa } }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    chofer_rut
                    camion_patente
                    sucursal_codigo
                    rut_empresa
                    fecha
                    limite_volumen
                    limite_peso
                    limite_monto
                    total_documentos
                    activo
                    fecha_hora_salida
                    fecha_registro
                    fecha_hora_retorno
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerSegunFiltro;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerRecoridosALiquidar(
    inputParams: {
      codigo: number;
      chofer_rut: number;
      fecha: Date | null;
      camion_patente: string;
      sucursal_codigo: number;
      rut_empresa: number;
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query (
            $codigo: Decimal
            $chofer_rut: Decimal
            $fecha: Date
            $camion_patente: String
            $sucursal_codigo: Decimal
            $rut_empresa: Decimal
            $listaEstado: [Decimal]
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            recorrido {
              obtenerRecoridosALiquidar(
                filtro: {
                  exacto: {
                    codigo: $codigo
                    chofer_rut: $chofer_rut
                    fecha: $fecha
                    camion_patente: $camion_patente
                    sucursal_codigo: $sucursal_codigo
                    rut_empresa: $rut_empresa
                    listaEstado: $listaEstado
                  }
                }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    chofer_rut
                    camion_patente
                    sucursal_codigo
                    rut_empresa
                    fecha
                    limite_volumen
                    limite_peso
                    limite_monto
                    total_documentos
                    activo
                    fecha_hora_salida
                    fecha_registro
                    fecha_hora_retorno
                    codigo_estado
                    nombre_estado
                    chofer_nombre
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerRecoridosALiquidar;
        callback({ mensajes, respuesta });
      }
    );
  }

  guardar(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          mutation ($entidad: recorridoInputType) {
            recorrido {
              guardar(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  codigo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.guardar;
        callback({ mensajes, respuesta });
      }
    );
  }

  GuardarRecorridoClonacion(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          mutation ($entidad: [recorridoInputType]) {
            recorrido {
              guardarRecorridoClonacion(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  codigo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.guardarRecorridoClonacion;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerRecorridos(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: recorridoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            recorrido {
              obtenerRecorridos(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    chofer_rut
                    nombreChofer
                    camion_patente
                    fecha
                    total_documentos
                    activo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerRecorridos;
        callback({ mensajes, respuesta });
      }
    );
  }

  eliminar(inputParams, callback: Function) {
    console.log('eliminar');
    this.gqlclient.query(
      {
        query: gql`
          mutation ($entidad: recorridoInputType) {
            recorrido {
              eliminar(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.eliminar;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerListadoRecorridosDevoluciones(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: FiltroInputTypeOfrecorridoTOrecorridoInputType) {
            recorrido {
              obtenerRecoridosConDevoluciones(filtro: $entidad) {
                mensajes {
                  codigo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    chofer_rut
                    camion_patente
                    fecha
                    fecha_hora_salida
                    nombreChofer
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerRecoridosConDevoluciones;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerChoferyPatenteRecorrido(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: FiltroInputTypeOfrecorridoTOrecorridoInputType) {
            recorrido {
              obtenerSegunFiltro(filtro: $entidad) {
                mensajes {
                  codigo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    chofer_rut
                    camion_patente
                    nombreChofer
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerSegunFiltro;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerReporteDevoluciones(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $recorridos: [Decimal], $paginaActual: Int, $cantidadRegistrosPagina: Int) {
            recorrido {
              obtenerDevolucionesxRecorrido(
                rutEmpresa: $rutEmpresa
                sucursalCodigo: $sucursalCodigo
                recorridos: $recorridos
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    producto_codigo
                    descripcion
                    sku
                    descFamilia
                    codigoFamilia
                    formato
                    bultos
                    unidades
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerDevolucionesxRecorrido;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerDevolucionesxRecorridoExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $recorridos: [Decimal]) {
            recorrido {
              obtenerDevolucionesxRecorridoExcel(rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo, recorridos: $recorridos) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerDevolucionesxRecorridoExcel;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerDevolucionesxRecorridoPDF(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $recorridos: [Decimal]) {
            recorrido {
              obtenerDevolucionesxRecorridoPDF(rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo, recorridos: $recorridos) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerDevolucionesxRecorridoPDF;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerConsultaRecorridoVistaResumen(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: recorridoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            recorrido {
              obtenerConsultaRecorridoVistaResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    chofer_rut
                    camion_patente
                    sucursal_codigo
                    rut_empresa
                    fecha
                    limite_volumen
                    limite_peso
                    limite_monto
                    total_documentos
                    activo
                    fecha_hora_salida
                    fecha_registro
                    fecha_hora_retorno
                    nombreChofer
                    despachado
                    codigo_estado
                    nombre_estado
                    total_liq
                    fecha_liq
                    efectivo
                    transferencia
                    deposito
                    cheque
                    nota_credito
                    nota_debito
                    reverso
                    cobro_vendedor
                    anticipo
                    cargo_transp
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerConsultaRecorridoVistaResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerConsultaRecorridoVistaResumenExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: recorridoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            recorrido {
              obtenerConsultaRecorridoVistaResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerConsultaRecorridoVistaResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerConsultaRecorridoVistaDetalle(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: recorridoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            recorrido {
              obtenerConsultaRecorridoVistaDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    recorrido_codigo_repetido
                    chofer_rut
                    camion_patente
                    sucursal_codigo
                    rut_empresa
                    fecha
                    limite_volumen
                    limite_peso
                    limite_monto
                    total_documentos
                    activo
                    fecha_hora_salida
                    fecha_registro
                    fecha_hora_retorno
                    nombreChofer
                    despachado
                    codigo_estado
                    nombre_estado
                    total_liq
                    fecha_liq
                    efectivo
                    transferencia
                    deposito
                    cheque
                    nota_credito
                    cobro_vendedor
                    anticipo
                    cargo_transp
                    folio
                    nota_debito
                    reverso
                    cliente_proveedor_rut
                    razon_social
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerConsultaRecorridoVistaDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerConsultaRecorridoVistaDetalleExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: recorridoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            recorrido {
              obtenerConsultaRecorridoVistaDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerConsultaRecorridoVistaDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerConsultaRecorridoDetalle(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: recorridoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            recorrido {
              obtenerConsultaRecorridoDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    chofer_rut
                    camion_patente
                    sucursal_codigo
                    rut_empresa
                    fecha
                    limite_volumen
                    limite_peso
                    limite_monto
                    total_documentos
                    activo
                    fecha_hora_salida
                    fecha_registro
                    fecha_hora_retorno
                    nombreChofer
                    despachado
                    codigo_estado
                    nombre_estado
                    total_liq
                    fecha_liq
                    efectivo
                    transferencia
                    deposito
                    cheque
                    nota_credito
                    cobro_vendedor
                    anticipo
                    cargo_transp
                    folio
                    nota_debito
                    reverso
                    cliente_proveedor_rut
                    razon_social
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerConsultaRecorridoDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerConsultaRecorridoDetalleExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: recorridoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            recorrido {
              obtenerConsultaRecorridoDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido.obtenerConsultaRecorridoDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }
}
